import { format } from "date-fns";
import { fr, enGB, es, it, pt, ru } from "date-fns/locale";
import { formatInTimeZone } from 'date-fns-tz';

const mapFNSLocales = {
  "fr": fr,
  "en": enGB,
  "es": es,
  "it": it,
  "pt": pt,
  "ru": ru
};

export const formatDateHour = (dateText) => {
  return format(new Date(dateText), "PPPp", { locale: mapFNSLocales["fr"] });
};

export const formatDate = (dateText, timeZone = 'Europe/Paris') => {
  return formatInTimeZone(new Date(dateText), timeZone, "PPP", { locale: mapFNSLocales["fr"] });
};